<div class="ac-page c7-access-view c7-access-accept">

  <header class="ac-topbar">
    <div class="ac-topbar__inner">
      <a class="ac-brand" href="javascript:void(0)" [attr.aria-label]="'CULTURA'">
        <img src="assets/logo-blue.png" alt="CULTURA" class="ac-brand__logo" />
      </a>
      <label class="ac-lang">
        <span>{{ "acceptPage.language" | translate }}</span>
        <select [value]="selectedLanguage" (change)="changeLanguage($any($event.target).value)">
          <option *ngFor="let lang of supportedLanguages" [value]="lang.code">{{ lang.name }}</option>
        </select>
      </label>
    </div>
  </header>

  <div class="ac-mobile-hint" role="note" *ngIf="state === 'ready'">
    <strong>{{ "acceptPage.mobileHintStrong" | translate }}</strong>
    {{ "acceptPage.mobileHint" | translate }}
  </div>

  <main class="ac-main">

    <!-- Einladung wird geladen -->
    <p class="ac-status" *ngIf="state === 'loading'" role="status">{{ "acceptPage.loading" | translate }}</p>

    <!-- Link ungültig oder abgelaufen -->
    <section class="ac-card ac-card--center" *ngIf="state === 'invalid'" aria-labelledby="ac-invalid-title">
      <h2 id="ac-invalid-title">{{ "acceptPage.invalidTitle" | translate }}</h2>
      <p class="ac-card__sub">{{ "acceptPage.invalidText" | translate }}</p>
      <a class="ac-btn ac-btn--link" routerLink="/login">{{ "acceptPage.invalidLogin" | translate }}</a>
    </section>

    <ng-container *ngIf="state === 'ready'">
      <section class="ac-intro" aria-labelledby="ac-welcome-title">
        <p class="ac-eyebrow">{{ "acceptPage.eyebrow" | translate: { company: invitation.company_name } }}</p>
        <h1 id="ac-welcome-title">{{ "acceptPage.title" | translate: { name: fullName } }}</h1>
        <p class="ac-lead">{{ "acceptPage.lead" | translate }}</p>

        <div class="ac-facts">
          <h2>{{ "acceptPage.factsTitle" | translate }}</h2>
          <ul>
            <li>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 6h12M8 12h12M8 18h12"/><circle cx="4" cy="6" r="1"/><circle cx="4" cy="12" r="1"/><circle cx="4" cy="18" r="1"/></svg>
              <span><strong>{{ "acceptPage.fact1Strong" | translate }}</strong> {{ "acceptPage.fact1" | translate }}</span>
            </li>
            <li>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="13" width="4" height="7" rx="1"/><rect x="10" y="8" width="4" height="12" rx="1"/><rect x="16" y="4" width="4" height="16" rx="1"/></svg>
              <span><strong>{{ "acceptPage.fact2Strong" | translate }}</strong> {{ "acceptPage.fact2" | translate }}</span>
            </li>
            <li>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
              <span><strong>{{ "acceptPage.fact3Strong" | translate }}</strong>, {{ "acceptPage.fact3" | translate }}</span>
            </li>
            <li>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l4 4L19 6"/></svg>
              <span><strong>{{ "acceptPage.fact4Strong" | translate }}</strong>, {{ "acceptPage.fact4" | translate }}</span>
            </li>
          </ul>
          <p class="ac-facts__note">{{ "acceptPage.factsNote" | translate }}</p>
        </div>
      </section>

      <section class="ac-card" aria-labelledby="ac-access-title">
        <div class="ac-card__head">
          <h2 id="ac-access-title">{{ "acceptPage.cardTitle" | translate }}</h2>
          <p class="ac-card__sub">{{ "acceptPage.cardSub" | translate }}</p>
        </div>

        <form [formGroup]="form" (ngSubmit)="join()" novalidate class="ac-form">

          <div class="ac-field">
            <label for="ac-email">{{ "acceptPage.email" | translate }}</label>
            <input id="ac-email" type="email" formControlName="email" readonly autocomplete="username" aria-describedby="ac-email-help" />
            <span id="ac-email-help" class="ac-help">{{ "acceptPage.emailHelp" | translate }}</span>
          </div>

          <div class="ac-field">
            <label for="ac-password">{{ "acceptPage.password" | translate }}</label>
            <div class="ac-input-wrap">
              <input id="ac-password" [type]="showPassword ? 'text' : 'password'" formControlName="password"
                autocomplete="new-password" aria-describedby="ac-rules"
                [attr.aria-invalid]="submitted && !rulesMet ? 'true' : 'false'" />
              <button type="button" class="ac-toggle" (click)="showPassword = !showPassword"
                [attr.aria-label]="(showPassword ? 'acceptPage.hidePassword' : 'acceptPage.showPassword') | translate">
                <img [src]="showPassword ? 'assets/eye-slash.svg' : 'assets/eye.svg'" alt="" />
              </button>
            </div>
            <app-password-rules id="ac-rules" [password]="password" [similarTo]="similarTo"></app-password-rules>
            <span class="ac-error" *ngIf="submitted && !rulesMet">{{ "acceptPage.errorRules" | translate }}</span>
          </div>

          <div class="ac-field">
            <label for="ac-repeat">{{ "acceptPage.repeat" | translate }}</label>
            <div class="ac-input-wrap">
              <input id="ac-repeat" [type]="showRepeat ? 'text' : 'password'" formControlName="repeatpass"
                autocomplete="new-password"
                [attr.aria-invalid]="submitted && repeatMismatch ? 'true' : 'false'" />
              <button type="button" class="ac-toggle" (click)="showRepeat = !showRepeat"
                [attr.aria-label]="(showRepeat ? 'acceptPage.hidePassword' : 'acceptPage.showPassword') | translate">
                <img [src]="showRepeat ? 'assets/eye-slash.svg' : 'assets/eye.svg'" alt="" />
              </button>
            </div>
            <span class="ac-error" *ngIf="submitted && repeatMismatch" aria-live="polite">{{ "acceptPage.errorRepeat" | translate }}</span>
          </div>

          <div class="ac-field">
            <label for="ac-language">{{ "acceptPage.questionnaireLanguage" | translate }}</label>
            <select id="ac-language" formControlName="language" (change)="changeLanguage($any($event.target).value)">
              <option *ngFor="let lang of supportedLanguages" [value]="lang.code">{{ lang.name }}</option>
            </select>
          </div>

          <app-consent-checkboxes [form]="form" [submitted]="submitted" [participant]="isParticipant"
            [company]="invitation.company_name" [purpose]="invitation.purpose" [purposeText]="invitation.purpose_text"></app-consent-checkboxes>

          <button class="ac-btn" type="submit" [disabled]="isLoading || !consentsGiven">
            {{ (isLoading ? "acceptPage.submitting" : "acceptPage.submit") | translate }}
          </button>
          <p class="ac-error ac-error--block" *ngIf="serverError" role="alert">{{ serverError }}</p>
        </form>

        <p class="ac-card__alt">
          {{ "acceptPage.alreadyHave" | translate }}
          <a routerLink="/login">{{ "acceptPage.alreadyLogin" | translate }}</a>
        </p>
      </section>
    </ng-container>
  </main>

  <app-auth-footer></app-auth-footer>
</div>
